import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { SeoService } from './seo.service';
import { BehaviorSubject, forkJoin, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

export interface MetaTags {
    property: string;
    content: string;
}

@Component({
    selector: 'app-seo',
    template: '',
})
export abstract class SeoComponent implements OnInit, OnDestroy {
    seoService = inject(SeoService);

    seoTitle$ = new BehaviorSubject<string>('');
    seoDescription$ = new BehaviorSubject<string>('');

    subscriptions$ = new Subscription();

    ngOnInit(): void {
        this.subscriptions$.add(
            forkJoin({
                title: this.seoTitle$.pipe(tap((currentTitle) => this.seoService.metaTagsBuilder({ title: currentTitle }))),
                description: this.seoDescription$.pipe(tap((currentDescription) => this.seoService.metaTagsBuilder({ description: currentDescription }))),
            }).subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }
}
